import { AchievementYear } from '@/models/reward';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'CmgRewardsAchievementsBody',
})
export default class CmgRewardsAchievementsBody extends Vue {
  @Prop({ required: true, type: Array })
  achievementYears!: AchievementYear[];
}
